import React, {useEffect, useState} from 'react';
import ReactDOM from 'react-dom';

const Portal = ({children, containerId}) => {
	const [container, setContainer] = useState(null);

	useEffect(() => {
		const el = document.getElementById(containerId);
		setContainer(el);
	}, []);

	if (!container) return null;

	return ReactDOM.createPortal(children, container);
};

export default Portal;